/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { TaskDataModel, TaskDatumType } from '../../../../../../models/task.model';

@Component({
  selector: 'app-task-datum-viewer',
  templateUrl: './task-datum-viewer.component.html',
  styleUrls: ['./task-datum-viewer.component.scss'],
  standalone: false
})
export class TaskDatumViewerComponent implements OnInit {
  @Input() taskData!: TaskDataModel[];
  TaskDatumType = TaskDatumType;

  constructor() {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
  noSort = () => 0;
}
